/**
 * @returns the next ascending order number out items which have "order" property.
 */
export const getOrder = (items: { order: number }[]): number => Math.max(...items.map(item => item.order)) + 1;
